import {useEffect, useState} from "react";
import {Box, Button, Dialog, DialogContent, IconButton, Typography} from "@mui/material";
import BackspaceRoundedIcon from "@mui/icons-material/BackspaceRounded";
import PhoneIphoneRoundedIcon from "@mui/icons-material/PhoneIphoneRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {useKioskLang} from "../context/KioskSessionContext";

const MAX_LEN = 10;
const isMobile = (value) => /^09\d{8}$/.test(value);

//手機號碼輸入：大按鍵數字盤（同桌號彈窗），避免叫出 iPad 系統鍵盤
//用途：內用「我要集點」、外帶取餐手機必填（按下一步未填時跳出）
export default function MobileNumberDialog({open, hint, initial = "", onClose, onConfirm}) {
  const {tr} = useKioskLang();
  const [value, setValue] = useState("");

  useEffect(() => {
    if (open) setValue(initial || "");
  }, [open, initial]);

  const press = (digit) => setValue((prev) => (prev + digit).slice(0, MAX_LEN));
  const erase = () => setValue((prev) => prev.slice(0, -1));
  const canConfirm = isMobile(value);
  //顯示 0912 345 678 分段方便核對
  const display = value ? `${value.slice(0, 4)} ${value.slice(4, 7)} ${value.slice(7)}`.trim() : "";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{p: 3.5, pt: 3}}>
        <Box sx={{display: "flex", alignItems: "center", gap: 1.25}}>
          <PhoneIphoneRoundedIcon color="primary" sx={{fontSize: 32}}/>
          <Box sx={{flex: 1}}>
            <Typography sx={{fontSize: 25, fontWeight: 950}}>{tr("enterMobileTitle")}</Typography>
            {hint && <Typography color="text.secondary" sx={{fontSize: 15.5}}>{hint}</Typography>}
          </Box>
          <IconButton aria-label={tr("cancel")} onClick={onClose}><CloseRoundedIcon/></IconButton>
        </Box>
        <Box sx={{mt: 2, minHeight: 84, borderRadius: 1.5, bgcolor: "#F7F1E8", border: "2px solid rgba(80,55,40,.15)", display: "flex", alignItems: "center", justifyContent: "center"}}>
          <Typography sx={{fontSize: 38, fontWeight: 950, letterSpacing: ".06em", color: value ? "text.primary" : "#B39D8D"}}>
            {display || "09"}
          </Typography>
        </Box>
        {value.length === MAX_LEN && !canConfirm && <Typography sx={{mt: 1, fontSize: 14.5, fontWeight: 800, color: "error.main", textAlign: "center"}}>{tr("mobileFormatError")}</Typography>}
        <Box sx={{mt: 2, display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1.25}}>
          {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((digit) => (
            <Button key={digit} onClick={() => press(digit)} sx={{minHeight: 74, fontSize: 30, fontWeight: 900, bgcolor: "#FFF", color: "text.primary", border: "1px solid rgba(80,55,40,.15)", "&:hover": {bgcolor: "#FFF8F0"}}}>{digit}</Button>
          ))}
          <Button onClick={erase} aria-label={tr("keypadDelete")} disabled={!value} sx={{minHeight: 74, color: "text.secondary", border: "1px solid rgba(80,55,40,.15)"}}><BackspaceRoundedIcon sx={{fontSize: 30}}/></Button>
          <Button onClick={() => press("0")} sx={{minHeight: 74, fontSize: 30, fontWeight: 900, bgcolor: "#FFF", color: "text.primary", border: "1px solid rgba(80,55,40,.15)", "&:hover": {bgcolor: "#FFF8F0"}}}>0</Button>
          <Button variant="contained" onClick={() => onConfirm(value)} disabled={!canConfirm} sx={{minHeight: 74, fontSize: 22, fontWeight: 950}}>{tr("confirm")}</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
